import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Information from '../../../../../Shared/Card/Information';
import { GetReinstatementInformationContent } from '../../../../../Shared/InformationContent/EFInformation';
import reinstatementService from '../../../../../../services/Public/Reinstatement/EF/efReinstatement.service';
import baseReinstatementService from '../../../../../../services/Public/Reinstatement/reinstatement.service';
import { useSelector } from 'react-redux';
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner';
import { Form, Schema } from 'rsuite';
import FormActionButtons from '../../../../../Shared/FormAction/FormActionButtons';
import SupervisingProfessional from '../../../../../Shared/Card/SupervisingProfessional';
import Issues from '../../../../../Shared/Card/Issues';
import SupervisingProfessionalWithAttestation from '../../../../../Shared/Card/SupervisingProfessionalWithAttestation';

function SupervisingProfessionalPage() {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [sectionData, setSectionData] = useState({});
    const routes = useSelector(x => x.currentRoutes);
    const sectionId = 13;
    const firmName = useSelector(x => x.userInfo.FirmName)
    const [firmLicenseNumber, setFirmLicenseNumber] = useState(null);
    const { StringType, BooleanType } = Schema.Types;
    const currentVersion = sectionData.hasFirmSubmittedSupervisingProfessional != null ? 1 : 2;//if there is a value to this radio button, we are in version one and dont show attestations.
    const model = Schema.Model({
        hasFirmSubmittedSupervisingProfessional: BooleanType().when((schema) => {
            return currentVersion == 1 ? BooleanType().isRequired('This field is required.') : BooleanType();
        }),
        electronicSignature: StringType().isRequired('This field is required.')
    });
    useEffect(() => {
        setHasLoaded(false);
        reinstatementService.efGetSection(reinstatementId, sectionId).then((response) => {
            setSectionData(response.data);
            baseReinstatementService.getFirmLicenseNumber("EF").then((licenseNum) => {
                setFirmLicenseNumber(licenseNum.data);
                setHasLoaded(true);
            })
        })


    }, [])
    const reinstatementId = useSelector(x => x.currentApplicationId);

    const push = useNavigate();

    const handleSubmit = (val, event) => {
        if (!sectionData.isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else {
            if (val) {
                reinstatementService.efPostSection(reinstatementId, sectionId, sectionData.electronicSignature).then((response) => {
                    if (currentVersion == 1) {
                        reinstatementService.efPostSectionHasFirmSubmittedSupervisingProfessional(reinstatementId, sectionId, sectionData.hasFirmSubmittedSupervisingProfessional).then((data) => {
                            if (response.data) {
                                if (data.data) {
                                    push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
                                }
                            }
                        })
                    }
                    else {
                        if (response.data) {
                            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
                        }
                    }
                })
            }
        }
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <div>
            <Container fluid>
                <Form model={model} onSubmit={handleSubmit} onChange={setSectionData} fluid formValue={sectionData}>
                    <strong>Engineering Firm Reinstatement</strong>
                    <h4 className="mb-3">Supervising Professional</h4>
                    <Row className="mb-3">
                        <Col> <Information content={GetReinstatementInformationContent("supervisingProfessional")} /></Col>
                    </Row>
                    {hasLoaded ?
                        <>
                            <Row className="mb-3">
                                <Col>
                                    {currentVersion == 1 ?
                                        <SupervisingProfessional
                                            supervisingProfessionalLink="/firm/supervisingprofessional"
                                            isReadOnly={!sectionData.isUserEditable}
                                            prefix={"EF"}
                                            sectionId={sectionId}
                                            sectionDataId={sectionData.id}
                                            parentTypeId={2}
                                            firmName={firmName}
                                            firmCredential={firmLicenseNumber}
                                            parentId={reinstatementId}
                                            entityId={sectionData.entityId}
                                        /> :
                                        <SupervisingProfessionalWithAttestation
                                            supervisingProfessionalLink="/firm/supervisingprofessional"
                                            isReadOnly={!sectionData.isUserEditable}
                                            prefix={"EF"}
                                            sectionId={sectionId}
                                            sectionDataId={sectionData.id}
                                            parentTypeId={2}
                                            firmName={firmName}
                                            firmCredential={firmLicenseNumber}
                                            parentId={reinstatementId}
                                            entityId={sectionData.entityId}
                                        />
                                    }
                                </Col>
                            </Row>
                            <br />
                            <Issues isUserEditable={true} type={2} sectionId={sectionData.id} />
                            <FormActionButtons nextSectionCallback={nextSectionNavigation} isReadOnly={!sectionData.isUserEditable} backToSectionLink="/firm/efreinstatement/sections" />
                        </> : <LoadingSpinner />
                    }
                </Form>
            </Container>
        </div>
    );
}
export default SupervisingProfessionalPage